import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiTranslateModule } from '@fcom/ui-translate';
import { UiComponentsModule } from '@fcom/ui-components';
import { CmsModule } from '@fcom/cms/components';
import { ComponentsModule, DirectiveModule, PipesModule, FinFormsModule } from '@fcom/common';
import { FeedbackWidgetModule } from '@fcom/common/components/feedback-widget/feedback-widget.module';
import { CommonBookingAncillariesModule, CommonBookingComponentsModule } from '@fcom/common-booking';
import { AlternativeOffersService } from '@fcom/reaccommodation/services/alternative-offers.service';
import { SubViewModule } from '@fcom/common-booking/components/subview/subview.module';
import { AncillarySubviewModule } from '@fcom/common-booking/modules/ancillaries/components/ancillary-subview/ancillary-subview.module';

import { ManageBookingViewRouteComponent } from './routes/view-route.component';
import { ViewGuard } from './services/view.guard';
import { ManageBookingCommonModule } from '../common/booking-common.module';
import { ManageBookingAncillariesComponent } from './components/ancillaries/ancillaries.component';
import { MmbPromotionComponent } from './components/promotion/promotion.component';
import { AncillaryCampaignComponent } from './components/ancillaries/ancillary-campaign.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    CommonBookingComponentsModule,
    CmsModule,
    PipesModule,
    DirectiveModule,
    UiTranslateModule,
    UiComponentsModule,
    ManageBookingCommonModule,
    CommonBookingAncillariesModule,
    FeedbackWidgetModule,
    SubViewModule,
    AncillarySubviewModule,
    FinFormsModule,
  ],
  declarations: [
    ManageBookingViewRouteComponent,
    ManageBookingAncillariesComponent,
    MmbPromotionComponent,
    AncillaryCampaignComponent,
  ],
  exports: [ManageBookingViewRouteComponent],
  providers: [AlternativeOffersService, ViewGuard],
})
export class ManageBookingViewModule {}
